import { StyledModal } from 'components/Modal.styled'
import { Button, Form, Modal, ModalProps } from 'react-bootstrap'
import { StyledRow, StyledWelcomeModal } from './WelcomeModal.styled'
import { getSystemSetting } from 'common/systemSettingsCode'
import { ISystemSetting } from 'types/baseTypes'
import { HTMLText } from 'components/Share/HtmlText'
import { useState } from 'react'
import { dismissWelcomeMessage } from 'apis/userApis'

interface IProps extends ModalProps {
  onHide: () => void
}

export const WelcomeModal = ({ onHide }: IProps) => {
  const [isDismissMessage, setIsDismissMessage] = useState(false)
  const welcomeMessage = (getSystemSetting('COLISTING_WELCOME_MESSAGE') as unknown as ISystemSetting)?.ValueString || ''

  const onSave = async (data: { dismissMessage: boolean }) => {
    try {
      if (isDismissMessage) {
        await dismissWelcomeMessage()
      }
    } catch (error) {
      console.error('Error dismissing welcome message:', error)
    } finally {
      onHide()
    }
  }

  return (
    <StyledModal show={true} onHide={onHide} centered customWidth={'750px'}>
      <StyledWelcomeModal>
        <Modal.Header closeButton>
          <Modal.Title>Welcome</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HTMLText value={welcomeMessage} />
          <StyledRow>
            <Form.Check
              custom
              id="dismissMessageCheckbox"
              onChange={(e) => setIsDismissMessage(e.target.checked)}
              checked={isDismissMessage}
              label={"Don't show this message again"}
            />
            <Button onClick={() => onSave({ dismissMessage: isDismissMessage })}>Continue to site {'>>>'}</Button>
          </StyledRow>
        </Modal.Body>
      </StyledWelcomeModal>
    </StyledModal>
  )
}
